<template>
  <vs-row vs-type="flex" vs-w="12" id="dashBoardPage">
    <stock-order-report v-if="dataSet.stockOrders" @reload="reloadStockOrders" :reportData="dataSet.stockOrders" ref="stockOrderPage"
      @close="isActiveStockOrder = false" />
    <vs-row vs-type="flex" vs-w="12" id="dashBoardTableOptions" class="py-2 sale-box-shadow low-border-radius bg-white"
      vs-justify="center">
      <vs-col vs-type="flex" vs-w="4" class="px-4 border-right border-divider" vs-justify="space-between" vs-align="center"
        id="dashBoardTableOptionsDate">
        <vs-button @click="tableOptions.defaultTimeRange = range"
          :class="{'text-primary' : isSelectedRange(range),'text-secondaryDark' : !isSelectedRange(range)}"
          :style="[!isSelectedRange(range) ? {'border-bottom-width':'0!important'} : {'border-bottom-width':'2px!important'}]"
          type="line" :color="isSelectedRange(range) ? 'primary' : 'secondary'" class="mx-2 px-0 py-1 bold"
          v-for="range in dataSet.timeRanges" :key="range.id">
          {{range.dName}}
        </vs-button>
      </vs-col>
      <vs-col vs-type="flex" :vs-w="($isCenterBranch() || $isRegionalCenterBranch()) ? 5 : 8" class="px-4" vs-justify="space-between" vs-align="center"
        id="dashBoardTableOptionsProp">
        <vs-button @click="tableOptions.reportByProp = prop"
          :class="{'text-primary' : isSelectedProp(prop),'text-secondaryDark' : !isSelectedProp(prop)}"
          :style="[!isSelectedProp(prop) ? {'border-bottom-width':'0!important'} : {'border-bottom-width':'2px!important'}]"
          type="line" :color="isSelectedProp(prop) ? 'primary' : 'secondary'" class="mx-2 px-0 py-1 bold"
          v-for="prop in dataSet.reportProps" :key="prop.id">
          {{prop.dName}}
        </vs-button>
      </vs-col>
      <vs-col v-if="$isCenterBranch() ||$isRegionalCenterBranch()" vs-type="flex" vs-w="3" class="px-2 border-left border-divider"
        vs-justify="center" vs-align="center" id="dashBoardTableOptionsType">
        <v-select class="w-full weight-600 px-4 text-primary" @input="onBranchSelection" :clearable="false" placeholder="Şube Seçimi"
          itemid="id" label="name" v-model="tableOptions.branch" :options="dataSet.branches" />
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" id="dashBoardContent">
      <vs-col id="dashBoardBigCol" vs-type="block" vs-w="7.5" class="pr-2">
        <vs-row vs-type="flex" vs-w="12" id="dashBoardBigColContent">
          <vs-row vs-type="flex" vs-w="12" id="dashBoardBranchReport">
            <branch-or-personal-giro-min :stop="false" :isBranchesOrPersonal="dataSet.isBranchOrPersonal"
              :branchGiros="dataSet.byBranch.branchGiros" :payments="dataSet.byBranch.payments"
              :personalGiros="dataSet.byBranch.personalGiros" :totalsOfSales="dataSet.byBranch.totalsOfSales"
              :selectedTimeRange="getSelectedTimeRange.dName ? getSelectedTimeRange.dName : ''"
              :orderBy="tableOptions.reportByProp ? tableOptions.reportByProp.id : 0" />
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" id="dashBoardTimeReport" class="mt-3">
            <giro-by-time-min :stop="false" :reportData="dataSet.byHour"
              :selectedTimeRange="getSelectedTimeRange.dName ? getSelectedTimeRange.dName : ''" />
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" id="dashBoardDateReport" class="mt-3"
            v-if="tableOptions.defaultTimeRange && tableOptions.defaultTimeRange.id != 0">
            <giro-by-date-min :stop="false" :reportData="dataSet.byDate"
              :selectedTimeRange="getSelectedTimeRange.dName ? getSelectedTimeRange.dName : ''" />
          </vs-row>
        </vs-row>
      </vs-col>
      <vs-col id="dashBoardShortCol" vs-type="block" vs-w="4.5" class="pl-2">
        <vs-row vs-type="block" vs-w="12" id="dashBoardShortColContent">
          <vs-row vs-type="block" vs-w="12" id="dashBoardTargets" class="mt-4" v-if="isTargetShow && dataSet.targets">
            <target-report :reportData="dataSet.targets" :selectedBranch="tableOptions.branch" />
          </vs-row>
          <vs-row vs-type="block" id="dashBoardCategoryReport"
            class="w-full sale-box-shadow low-border-radius bg-white px-4 py-2"
            :class="{'mt-2' : isTargetShow, 'mt-4' : !isTargetShow}">
            <category-giro-min :table-options="tableOptions" :stop="false" :reportData="dataSet.byCategory"
              :showBranch="false" :orderBy="tableOptions.reportByProp ? tableOptions.reportByProp.id : 0" />
          </vs-row>
          <vs-row vs-type="block" id="dashBoardProductReport"
            class="w-full mt-4 sale-box-shadow low-border-radius bg-white px-4 py-2">
            <product-giro-min :table-options="tableOptions" :stop="false" :reportData="dataSet.byProduct"
              :showBranch="false" :orderBy="tableOptions.reportByProp ? tableOptions.reportByProp.id : 0" />
          </vs-row>
        </vs-row>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
  import StockOrderReport from "./StockOrderReport.vue";
  import TargetReport from "./TargetReport.vue";
  import GiroByTimeMin from "../Reports/GiroByTime/GiroByTimeMin.vue";
  import GiroByDateMin from "../Reports/GiroByDate/GiroByDateMin.vue";
  import ProductGiroMin from "../Reports/ProductGiro/ProductGiroMin.vue";
  import CategoryGiroMin from "../Reports/CategoryGiro/CategoryGiroMin.vue";
  import BranchOrPersonalGiroMin from "../Reports/BranchOrPersonalGiro/BranchOrPersonalGiroMin.vue";
  export default {
    data() {
      return {
        tableOptions: {},
      }
    },
    props: {
      dataSet: {
        required: true,
        type: Object
      }
    },
    components: {
      TargetReport,
      BranchOrPersonalGiroMin,
      CategoryGiroMin,
      ProductGiroMin,
      GiroByTimeMin,
      GiroByDateMin,
      StockOrderReport
    },
    computed: {
      getSelectedTimeRange() {
        if (!this.tableOptions.defaultTimeRange) return {};
        return this.dataSet.timeRanges.find(x => x.id === this.tableOptions.defaultTimeRange.id);
      },
      isTargetShow() {
        if (!this.tableOptions.branch) return false;
        return this.$isCenterBranch() && this.tableOptions.branch && this.tableOptions.branch.id > this.$centerBranchId && this.dataSet
          .targets;
      }
    },
    methods: {
      reloadStockOrders() {
        this.$emit("reloadStockOrders")
      },
      clearFilter() {
        let nowHour = new Date(Date.now()).getHours()
        this.tableOptions = {
          branch: {
            id:null,
            name:"Tüm Şubeler"
          },
          defaultTimeRange: nowHour >= 0 && nowHour <= 2 ? {
            name: "Yesterday",
            id: 0,
            dName: "Dün"
          } : {
            name: "Today",
            id: 1,
            dName: "Bugün"
          },
          reportByProp: {
            name: "Amount",
            id: 0,
            dName: "Ciroya Göre"
          },
          takeCount:10,
          category: null
        };
      },
      openStockOrderPage() {
        this.$refs.stockOrderPage.isActive = true;
      },
      onBranchSelection(val) {
        this.$emit("branchChanged", val)
      },
      isSelectedProp(prop) {
        if (!this.tableOptions.reportByProp || !prop) return false;
        if (prop.id === this.tableOptions.reportByProp.id) return true;
        return false;
      },
      isSelectedRange(range) {
        if (!this.tableOptions.defaultTimeRange || !range) return false;
        if (range.id === this.tableOptions.defaultTimeRange.id) return true;
        return false;
      },
    },
    mounted() {
      this.clearFilter();
      this.$root.$on('open-stock-order-report', this.openStockOrderPage);
    },
    beforeDestroy() {
      this.$root.$off('open-stock-order-report', this.openStockOrderPage);
    },
    watch: {
      tableOptions: {
        deep: true,
        handler(val) {
          this.$nextTick(() => {
            this.$emit("fetchData", this.tableOptions);
          });
        }
      },
    }
  }

</script>

<style>
  .text-secondaryDark {
    color: rgba(var(--vs-secondaryDark), 1) !important;
  }

  #dashBoardTableOptions .vs__dropdown-toggle {
    border: none !important;
    padding: 0 !important;
  }

  #dashBoardTableOptions .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: auto !important;
    overflow-y: auto !important;
    width: 100% !important;
    min-width: unset !important;

  }

  #dashBoardTableOptions .vs__selected {
    color: rgba(var(--vs-primary), 1);
    font-weight: 600;
    margin: auto !important;
    position: unset !important;
  }

  #dashBoardTableOptions .v-select .vs__dropdown-toggle .vs__search {

  }

  #dashBoardActionsCol .pickicon {
    font-size: 1.9rem !important;
  }

  #dashBoardActionsCol .includeIconOnly {
    height: 45px !important;
  }
</style>
